module.exports = {
    licence:{
        Robot_problem_solved:'Hilfreich',
        Robot_problem_unsolved:'Hat nicht geholfen',
        Robot_emptyMassege_reminder:"Leere Nachricht kann nicht gesendet werden",
        Robot_massege_ViewMore:'Mehr sehen',
        Robot_massege_ViewLess:'Weniger anzeigen',
        Robot_greetings_1:'Hallo, was können wir für Sie tun?',
        Robot_greetings_2:'Suchen Sie etwas anderes? Versuchen Sie, ein Schlüsselwort einzugeben, damit ich nach weiteren Informationen suchen kann, um Ihnen zu helfen!',
        Robot_closing_1_1:'Aww, Entschuldigung! Ich bin noch am Lernen. ',
        Robot_closing_1_2:'Bitte versuchen Sie es mit einem anderen Stichwort, oder klicken Sie einfach',
        Robot_closing_1_login_1:"Oh, Entschuldigung! Ich bin noch am Lernen. ",
        Robot_closing_1_login_2:'Bitte versuchen Sie es mit einem anderen Schlüsselwort!',
        Robot_closing_2:'HIER ',
        Robot_closing_3:'und kontaktieren Sie unser Support-Team. Wir werden uns so schnell wie möglich bei Ihnen melden!',
        Robot_problem_unsolved_reply:'Diesmal konnten wir Ihnen leider nicht mehr helfen. Ich habe Ihre jedoch Anfrage aufgeschrieben, damit wir unseren Support in Zukunft verbessern können! Bitte klicken Sie HIER und kontaktieren Sie unser Support-Team. Wir werden uns so schnell wie möglich bei Ihnen melden!',
        Robot_TypeHere:'Hier eingeben',
        Robot_greetings_label1:'Daten in der neuen App zusammenführen',
        Robot_greetings_label2:'Nach der Migration fehlen Daten',
        Robot_greetings_label3:'Die Waage ist nach der Migration nicht mehr angeschlossen',
        Robot_greetings_label4:'Empfehlungen nach der Migration',
        Robot_greetings_label5:'In der Karte gezeigte Grafiken',
        Robot_greetings_label6:"Gewichtsverlauf anzeigen",
        Robot_greetings_label7:"Umfangshistorie ansehen",
        Robot_greetings_label8:'Wo bekomme ich Hilfe',
        Robot_greetings_label9:'Sonstiges',
        key_internet_error:"Es gibtProbleme mit der Netzwerkverbindung. Bitte prüfen Sie IhreNetzwerkeinstellungen.",
        Robot_title_Beta:'ChatBot',
        Robot_greetings_label1_login:'Das Passwort vergessen',
        Robot_greetings_label2_login:'Zurücksetzen des Passworts',
        Robot_greetings_label3_login:'Daten in neuer APP zusammenführen',
        Robot_greetings_label4_login:'Wozu gibt es zwei APPs?',
        Robot_greetings_label5_login:'Hinweise zur Kontoanmeldung',
        Robot_greetings_label6_login:"Benötigt die neue APP eine neue Registrierung?",
        Robot_greetings_label7_login:"Was ist zu tun, wenn ich ein Konto bei beiden APPs habe?",
        Robot_greetings_label8_login:'Wo bekomme ich Hilfe',
        Robot_greetings_label9_login:'Sonstiges',
        Robot_greetings_label1_devicePage:'So fügen Sie ein Gerät hinzu',
        Robot_greetings_label2_devicePage:'Gerät über das "Gerät hinzufügen-Popup" hinzufügen',
        Robot_greetings_label3_devicePage:'Gerät manuell hinzufügen',
        Robot_greetings_label4_devicePage:'Tipps zur Kopplung der Wifi-Bluetooth-Waage',
        Robot_greetings_label5_devicePage:'Kopplung mit Wifi',
        Robot_greetings_label6_devicePage:"Gerät ist nicht unter 'GEKOPPELTE GERÄTE' aufgeführt",
        Robot_greetings_label7_devicePage:"Ein Gerät löschen",
        Robot_greetings_label8_devicePage:'Wo bekomme ich Hilfe',
        Robot_greetings_label9_devicePage:'Sonstiges',
        Robot_greetings_label1_mePage:'Kann ich den Hauptbenutzer ändern?',
        Robot_greetings_label2_mePage:'Wie man die Benutzerinformationen des Hauptbenutzers bearbeitet',
        Robot_greetings_label3_mePage:'Daten eines Freundes anzeigen',
        Robot_greetings_label4_mePage:'Einen Freund hinzufügen',
        Robot_greetings_label5_mePage:'Wie man eine Freundschaftsanfrage sendet',
        Robot_greetings_label6_mePage:"Wie man eine Freundschaftsanfrage überprüft",
        Robot_greetings_label7_mePage:"Einen Freund löschen",
        Robot_greetings_label8_mePage:'Wo bekomme ich Hilfe',
        Robot_greetings_label9_mePage:'Sonstiges',
        Robot_greetings_label1_balancePage:'Gewichtsdaten werden nicht mit der APP synchronisiert',
        Robot_greetings_label2_balancePage:'Wie man einen Bluetooth-Fehler überprüft',
        Robot_greetings_label3_balancePage:'APP zeigt nur Gewicht&BMI an',
        Robot_greetings_label4_balancePage:'Anzeige der Muskelmesswerte in "--"',
        Robot_greetings_label5_balancePage:'Die Waage wiegt nicht korrekt',
        Robot_greetings_label6_balancePage:"Der Körperfettanteil% verändert sich drastisch",
        Robot_greetings_label7_balancePage:"Gewichtsdaten manuell eingeben",
        Robot_greetings_label8_balancePage:'Zu einem anderen Messanwender wechseln',
        Robot_greetings_label9_balancePage:'Sonstiges',
        Robot_greetings_label1_tapPage:'Wie man das Maßband benutzt',
        Robot_greetings_label2_tapPage:'Zu einem anderen Messanwender wechseln',
        Robot_greetings_label3_tapPage:'Trenddiagramm zum Umfang anzeigen',
        Robot_greetings_label4_tapPage:'Umfangshistorie anzeigen',
        Robot_greetings_label5_tapPage:'Umfangsdaten manuell eingeben',
        Robot_greetings_label6_tapPage:"Wo bekomme ich Hilfe",
        Robot_greetings_label7_tapPage:"Sonstiges",
        savetoAlbum: 'Im Album gespeichert',
        key_cancel: 'Abbrechen',
        key_confirm: 'Bestätigen',
        key_deleted: 'Erfolgreich gelöscht',
        key_delete_popup: 'Der Verlauf kann nach dem Löschen nicht wiederhergestellt werden. Möchten sie ihn definitiv löschen?',
        key_delete_history: 'Chatverlauf löschen',
        key_delete_confirmation: 'Bestätigung löschen'

    }
}